import { getConfigurationSettingByDevelopmentKey, ConfigContentType } from "../../services/content/config.lib.js";
import { getLucidWorksGRSLocale } from "../../components/Search/SearchBar/lib.js";
async function lucidWorksService(q, url, locale) {
  const serviceConfig = await getConfigurationSettingByDevelopmentKey(
    ConfigContentType.ServiceConfiguration,
    "search_service_nav_config_usbc"
  );
  const {
    required_request_headers: headers,
    endpoint,
    custom_properties: { loc },
    authentification_token = ""
  } = serviceConfig;
  if (!endpoint || !locale) return null;
  const apiUrl = `${endpoint}?q=${q}&url=%2F${url}.html&loc=${loc}&locale=${getLucidWorksGRSLocale(locale)}`;
  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        ...headers,
        Authorization: `Basic ${authentification_token}`
      }
    }).then((res) => res.json());
    return response;
  } catch (err) {
    console.error("LucidWorks fetch failed", err);
    return null;
  }
}
export {
  lucidWorksService
};
